import KeyboardShortcut from './keyboard-shortcut';

export default KeyboardShortcut;
